Postlogin = (function (postlogin) {
    postlogin.AssessmentAssignmentsList = {};
    const self = postlogin.AssessmentAssignmentsList;
    const assignmentsTable = document.querySelector('#assignments-list-table');
    const assessmentId = $('#assignments-list-table').data('assessment-id');

    const initBootstrapTable = function () {
        $('#assignments-list-table').bootstrapTable({
            formatNoMatches() {
                return 'No assignments to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: `/assessments/${assessmentId}/assignments/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    title: 'Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        return new Date(value).toLocaleDateString('en-us', 'L');
                    },
                },
                {
                    title: 'Start Date',
                    field: 'start_date',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        return !value ? '' : new Date(value).toLocaleDateString('en-us', 'L');
                    },
                },
                {
                    title: 'Assigned By',
                    field: 'teacher_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        return `${row.first_name} ${row.last_name}`;
                    },
                },
                {
                    title: 'Subtitle',
                    field: 'subtitle',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assigned To',
                    field: 'number_assigned_to',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const url = self.viewUrl.replace(':assessment_id', row.assessment_id).replace(':assignment_id', row.assignment_id);
                        const students = row.number_assigned_to > 1 ? 'students' : 'student';
                        return `<a href="${url}" class="btn btn-hollow-dark-gray">${row.number_assigned_to} ${students}</a>`;
                    },
                },
                {
                    title: '% Completed',
                    field: 'percentage_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        return `${value}%`;
                    },
                },
                {
                    title: ' ',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter(value, row) {
                        const viewAssignmentUrl = self.viewUrl
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);
                        const editAssignmentUrl = self.editUrl
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);
                        const deleteAssignmentUrl = self.deleteUrl
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);

                        const editDelete = !row.can_manage
                            ? ''
                            : `
                                <a href="${editAssignmentUrl}" class="btn btn-hollow-blue">Edit</a>
                                <form action="${deleteAssignmentUrl}" method="post" class="delete-entry">
                                    <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                    <input type="hidden" name="_METHOD" value="DELETE"/>
                                    <button type="submit" class="btn btn-hollow-pink">Delete</button>
                                </form>
                            `;

                        return `
                            <a href="${viewAssignmentUrl}" class="btn btn-hollow-green">View</a>
                            ${editDelete}
                        `;
                    },
                },
            ],
            responseHandler(res) {
                return {
                    total: res.meta.total,
                    rows: res.data,
                };
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            rowStyle(row) {
                let classes = '';

                if (row.percentage_completed < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_completed < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_completed < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    self.init = function () {
        initBootstrapTable();
        self.viewUrl = assignmentsTable.dataset.viewUrl;
        self.editUrl = assignmentsTable.dataset.editUrl;
        self.deleteUrl = assignmentsTable.dataset.deleteUrl;
    };

    return postlogin;
}(Postlogin || {}));
